import React from "react";
import styled from "@emotion/styled";
import { Swiper } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const Container = styled(Swiper)(({ theme }) => ({
  maxWidth: "520px",
  width: "100%",
  height: "450px",
  borderRadius: "10px",

  ".swiper-pagination": {
    bottom: "2rem",
  },
  ".swiper-pagination-bullet": {
    width: "4px",
    height: "4px",
  },
  ".swiper-pagination-bullet-active": {
    backgroundColor: theme.color.mint,
  },
}));

const HomeEventSwiper = ({ children }: { children: React.ReactNode }) => {
  return (
    <Container
      modules={[Pagination, Autoplay]}
      spaceBetween={50}
      slidesPerView={1}
      autoplay={{ delay: 5000 }}
      pagination={{ clickable: false }}>
      {children}
    </Container>
  );
};

export default HomeEventSwiper;
